import {RootState} from '../../rootReducer';
import {calendarDaysAdapter, calendarWeeksAdapter} from './adapters';

export const getCalendarLoadingStatus = (state: RootState) => state.data.calendar.loadingStatus;

export const {
  selectById: getCalendarWeekById,
  selectIds: getCalendarWeekIds,
  selectEntities: getCalendarWeekEntities,
  selectAll: getAllCalendarWeeks,
  selectTotal: getTotalCalendarWeeks,
} = calendarWeeksAdapter.getSelectors((state: RootState) => state.data.calendar.weeks);

export const {
  selectById: getCalendarDayById,
  selectIds: getCalendarDayIds,
  selectEntities: getCalendarDayEntities,
  selectAll: getAllCalendarDays,
  selectTotal: getCalendarTotalDays,
} = calendarDaysAdapter.getSelectors((state: RootState) => state.data.calendar.days);
